import apiClient, { getApiBaseUrl } from './apiClient';

// ── Public ──────────────────────────────────────────────────

export const getPublicContests = async () => {
  const response = await apiClient.get('/api/contests');
  return response.data;
};

export const getContestById = async (id) => {
  const response = await apiClient.get(`/api/contests/${id}`);
  return response.data;
};

export const getContestResults = async (id) => {
  const response = await apiClient.get(`/api/contests/${id}/results`);
  return response.data;
};

export const getContestStats = async () => {
  const response = await apiClient.get('/api/contests/stats');
  return response.data;
};

export const getContestDetailStats = async (id) => {
  const response = await apiClient.get(`/api/contests/${id}/stats`);
  return response.data;
};

// ── Authenticated: Registration & Voting ────────────────────

export const registerNovel = async (contestId, novelId) => {
  const response = await apiClient.post(`/api/contests/${contestId}/entries`, { novelId });
  return response.data;
};

export const changeContestEntry = async (contestId, entryId, novelId) => {
  const response = await apiClient.put(`/api/contests/${contestId}/entries/${entryId}`, { novelId });
  return response.data;
};

export const voteForEntry = async (contestId, entryId) => {
  await apiClient.post(`/api/contests/${contestId}/entries/${entryId}/vote`);
};

export const removeVote = async (contestId, entryId) => {
  await apiClient.delete(`/api/contests/${contestId}/entries/${entryId}/vote`);
};

// ── Judge ───────────────────────────────────────────────────

export const respondToJudgeInvitation = async (contestId, accept) => {
  const response = await apiClient.post(`/api/contests/${contestId}/judge/respond`, { accept });
  return response.data;
};

export const submitJudgeScore = async (contestId, entryId, score, review) => {
  const response = await apiClient.post(`/api/contests/${contestId}/entries/${entryId}/judge-score`, { score, review });
  return response.data;
};

export const getMyJudgeScores = async (contestId) => {
  const response = await apiClient.get(`/api/contests/${contestId}/judge/scores`);
  return response.data;
};

export const getMyJudgeInvitations = async () => {
  const response = await apiClient.get('/api/contests/judge/invitations');
  return response.data;
};

// ── Admin: Contest CRUD ─────────────────────────────────────

export const getAllContests = async () => {
  const response = await apiClient.get('/api/contests/admin');
  return response.data;
};

export const createContest = async (contestData) => {
  const response = await apiClient.post('/api/contests/admin', contestData);
  return response.data;
};

export const updateContest = async (id, contestData) => {
  const response = await apiClient.put(`/api/contests/admin/${id}`, contestData);
  return response.data;
};

export const deleteContest = async (id) => {
  await apiClient.delete(`/api/contests/admin/${id}`);
};

export const transitionContestStatus = async (id, status) => {
  const response = await apiClient.patch(`/api/contests/admin/${id}/status`, { status });
  return response.data;
};

// ── Admin: Judge Management ─────────────────────────────────

export const addJudge = async (contestId, userId) => {
  const response = await apiClient.post(`/api/contests/admin/${contestId}/judges`, { userId });
  return response.data;
};

export const removeJudge = async (contestId, judgeId) => {
  await apiClient.delete(`/api/contests/admin/${contestId}/judges/${judgeId}`);
};

// ── Admin: Banner Upload ────────────────────────────────────

export const uploadContestBanner = async (contestId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await apiClient.post(`/api/contests/admin/${contestId}/banner`, formData);
  return response.data;
};

export const getContestBannerUrl = (bannerImageUrl) => {
  if (!bannerImageUrl) return null;
  if (bannerImageUrl.startsWith('http')) return bannerImageUrl;
  return `${getApiBaseUrl()}${bannerImageUrl}`;
};

// ── Admin: Per-Contest Badge Awards ──────────────────────────

export const getContestBadgeAwards = async (contestId) => {
  const response = await apiClient.get(`/api/contests/admin/${contestId}/badge-awards`);
  return response.data;
};

export const getPublicContestBadgeAwards = async (contestId) => {
  const response = await apiClient.get(`/api/contests/${contestId}/badge-awards`);
  return response.data;
};

export const createContestBadgeAward = async (contestId, data) => {
  const response = await apiClient.post(`/api/contests/admin/${contestId}/badge-awards`, data);
  return response.data;
};

export const deleteContestBadgeAward = async (contestId, awardId) => {
  await apiClient.delete(`/api/contests/admin/${contestId}/badge-awards/${awardId}`);
};
